import { z } from 'zod';
import { CulinaryStudioArticleCardModelSchema } from 'entities/culinary-studio-article';
import { GetCulinaryStudioArticleCardsByCategoryUidApiResponseSchema } from '../store';

// eslint-disable-next-line max-len
export const createCulinaryStudioArticleCardsFromGetCulinaryStudioArticleCardsByCategoryUidApiResponse = (
    (response: z.infer< typeof GetCulinaryStudioArticleCardsByCategoryUidApiResponseSchema>) => (
        response.data.map(({
            slug,
            name,
            images,
            category,
        }) => CulinaryStudioArticleCardModelSchema.parse({
            uid: slug,
            name,
            image: images?.[0].url && {
                url: images[0].url,
            },
            category: category && ({
                uid: category.slug,
            }),
        }))
    )
);
